import { cn } from '@/lib/utils';

interface KpiCardProps {
  label: string;
  value: string;
  delta?: { value: number; label: string };
  className?: string;
}

export function KpiCard({ label, value, delta, className }: KpiCardProps) {
  return (
    <div
      style={{
        padding: 20,
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
      className={cn('kpi-card', className)}
    >
      <div style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, marginTop: 8 }}>{value}</div>
      {delta && (
        <div
          style={{
            fontSize: 12,
            marginTop: 8,
            color: delta.value >= 0 ? '#16a34a' : '#dc2626',
          }}
        >
          {delta.value >= 0 ? '↑' : '↓'} {Math.abs(delta.value).toFixed(1)}% {delta.label}
        </div>
      )}
    </div>
  );
}
